<ng-container *ngIf="currentStep === 'confirm'">
    <mat-dialog-content class="p-6 max-w-lg max-h-full gap-6">
        <div class="relative flex flex-col w-full h-auto rounded-3xl items-center text-center">
            <button class="absolute -top-2 -right-2 text-gray-400 hover:text-gray-800 transition-colors cursor-pointer" (click)="close()">
                <i class="fi-rr-cross text-lg"></i>
            </button>
            
            <div class="w-18 h-18 rounded-full bg-background-warning flex items-center justify-center mb-4 shadow-sm">
                <div class="w-8 h-8 rounded-full flex items-center justify-center bg-orange-500">
                    <i class="fi-rr-exclamation text-base text-white"></i>
                </div>
            </div>
            <div class="flex flex-col w-full h-auto gap-2">
                <h2 class="text-3xl font-semibold mb-2">¿Confirmar pedido?</h2>
                <p class="text-sm mb-4">¿Estás seguro de realizar el pedido ahora?</p>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="p-6">
        <div class="flex w-full gap-4">
            <div class="flex-1 flex items-center">
                <button type="button" (click)="close()"
                    class="w-full rounded-full bg-white border border-gray-300 text-gray-700 py-3 hover:bg-gray-100 shadow font-semibold text-base cursor-pointer">
                    Cancelar
                </button>
            </div>
            <div class="flex-1 flex items-center">
                <button type="button" (click)="confirm()"
                    class="w-full rounded-full bg-primary-300 text-white py-3 hover:bg-orange-600 shadow-lg font-semibold text-base cursor-pointer">
                    Realizar Pedido
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="currentStep === 'processing'">
    <mat-dialog-content class="p-6 max-w-lg max-h-full gap-6">
        <div class="relative flex flex-col w-full h-auto rounded-3xl items-center text-center">
            <div class="w-18 h-18 rounded-full bg-background-positive flex items-center justify-center mb-4 shadow-sm">
                <div class="w-8 h-8 rounded-full flex items-center justify-center bg-primary-300 animate-pulse">
                    <i class="fi-rr-loading text-base text-white"></i>
                </div>
            </div>
            <div class="flex flex-col w-full h-auto gap-2">
                <h2 class="text-2xl font-semibold mb-2">Procesando tu pedido…</h2>
                <p class="text-sm mb-4">Esto puede tardar unos segundos.</p>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="p-6">
        <div class="flex w-full gap-4">
            <div class="flex-1 flex items-center justify-center">
                <span class="text-sm text-gray-600">Por favor espera…</span>
            </div>
        </div>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="currentStep === 'success'">
    <mat-dialog-content class="p-6 max-w-lg max-h-full gap-6">
        <div class="relative flex flex-col w-full h-auto rounded-3xl items-center text-center">
            <button class="absolute -top-2 -right-2 text-gray-400 hover:text-gray-800 transition-colors cursor-pointer" (click)="goHome()">
                <i class="fi-rr-cross text-lg"></i>
            </button>
            
            <div class="w-18 h-18 rounded-full bg-background-positive flex items-center justify-center mb-4 shadow-sm">
                <div class="w-8 h-8 rounded-full flex items-center justify-center bg-green-500">
                    <i class="fi-rr-check text-base text-white"></i>
                </div>
            </div>

            <div class="flex flex-col w-full h-auto gap-2">
                <h2 class="text-3xl font-semibold mb-2">¡Pedido confirmado con éxito!</h2>
                <p class="text-sm mb-4">Recibimos tu pedido correctamente. Puedes consultarlo, hacer
                    seguimiento y descargar el comprobante cuando lo necesites.</p>
                <div class="mb-4">
                    <span
                        class="inline-block bg-data-visualization text-black px-3 py-1 gap-2 rounded-full text-sm font-medium">{{
                        orderNumber || data?.orderNumber || '—' }}</span>
                </div>
            </div>

            <div class="flex items-center gap-3 w-full mb-4">
                <div class="flex items-center gap-3">
                    <i class="fi-rr-truck-side text-2xl"></i>
                    <div class="text-left">
                        <div class="flex items-center gap-2">
                            <div class="text-base">Tiempo estimado de entrega:</div>
                            <div class="font-bold">{{data?.leadTime}} días</div>
                        </div>
                        <p class="text-xs text-text-secondary mb-4">Estamos preparando todo. Te notificaremos cuando
                            esté en
                            camino.</p>
                    </div>
                </div>
            </div>

        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="p-6">
        <div class="flex w-full gap-4">
            <div class="flex-1 flex items-center justify-center">
                <a href="#" (click)="$event.preventDefault(); downloadOrder()"
                    class="text-sm text-gray-700 hover:underline text-center cursor-pointer">Descargar pedido</a>
            </div>

            <div class="flex-1 flex items-center">
                <button type="button" (click)="goHome()"
                    class="w-full rounded-full bg-primary-300 text-white py-3 hover:bg-orange-600 shadow-lg font-semibold text-base cursor-pointer">
                    Ir al inicio
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</ng-container>